export class EpsQuote {
    tenant_assigned_quotes_id: number;
    vehicle_type_id: number
    quota: number
    spot_type_id: number
    association_enabled: boolean
}